import { useQuery } from '@tanstack/react-query';
import { keepPreviousData } from '@tanstack/react-query';
import LotsService from '../services/lots.service';
import { Lot } from '../common/model/dto/lot';
import { LotCalibrationDataResponse } from '../common/model/dto/lot-calibration-data';

export interface UseLotCalibrationDataParams {
  lotId: string;
  errorMargin?: number;
  enabled?: boolean;
}

export const useLotCalibrationData = ({
  lotId,
  errorMargin = 5,
  enabled = true,
}: UseLotCalibrationDataParams) => {
  return useQuery<Lot & { calibrationData?: LotCalibrationDataResponse }>({
    queryKey: ['lot', lotId, 'calibration', errorMargin],
    queryFn: () => LotsService.getLotWithCalibrationData(lotId, errorMargin),
    enabled: enabled && !!lotId,
    staleTime: 30000, // 30 seconds
    placeholderData: keepPreviousData, // Keep previous data while loading new data
  });
};

